import { z } from '@hono/zod-openapi'
import { vouchersTable } from '@mattrika/benefit-db'
import { createInsertSchema, createSelectSchema } from 'drizzle-orm/zod'
import { zCommonQuery } from '../common/common.model'

export type InsertVoucher = z.infer<typeof zInsertVoucher>
export type SelectVoucher = z.infer<typeof zSelectVoucher>
export type UpdateVoucher = z.infer<typeof zUpdateVoucher>
export type QueryVouchers = z.infer<typeof zQueryVouchers>
export type ColumnsOfVouchersTable = keyof typeof vouchersTable._.columns

export const zSelectVoucher = createSelectSchema(vouchersTable)
export const zInsertVoucher = createInsertSchema(vouchersTable).omit({
    id: true,
    createdAt: true,
    updatedAt: true,
})
export const zUpdateVoucher = zInsertVoucher.partial()
export const zQueryVouchers = zInsertVoucher
    .extend({ id: z.string(), ids: z.string().array() })
    .extend(zCommonQuery.shape)
    .partial()
